/** Dispatched on `.ccr-sec` roots to expand a collapsed section card. */
export const CCR_EXPAND_SECTION_EVENT = 'ccr-expand-section';

/** Walk up the DOM and expand every collapsed section containing `el`. */
export function expandCollapsibleAncestors(el: HTMLElement): void {
  let node: HTMLElement | null = el;
  while (node) {
    if (node.classList.contains('ccr-sec')) {
      node.dispatchEvent(new CustomEvent(CCR_EXPAND_SECTION_EVENT, { bubbles: false }));
    }
    node = node.parentElement;
  }
}
